import store from '@/store'
import { getCKOPublicKeyByCurrency } from '@/utils/currency-config'

const makeAuthorization = (token) => (token ? `Bearer ${token}` : '')

const attachToken = ({ headers }) => {
  const common = headers?.common || {}
  const token = store.getters.token
  const authorization = makeAuthorization(token)

  if (authorization) {
    common.Authorization = authorization
  }

  return {
    headers: {
      ...headers,
      common: {
        ...common,
      },
    },
  }
}

const attachDeviceId = ({ headers }) => {
  const common = headers?.common || {}
  const deviceId = store.getters.deviceId

  if (deviceId) {
    common['X-Device-Id'] = deviceId
  }

  return {
    headers: {
      ...headers,
      common: {
        ...common,
      },
    },
  }
}

const attachCkoPublicKey = ({ headers }) => {
  const ckoPublicKey = getCKOPublicKeyByCurrency(
    store.getters['session/orderCurrency'],
    store.getters['configuration/isUsingCkoHubVersionV2']
  )

  if (!ckoPublicKey) {
    return headers
  }

  return {
    headers: {
      ...headers,
      'x-checkoutcom-pk': ckoPublicKey,
    },
  }
}

const headers = {
  attachToken,
  attachDeviceId,
  attachCkoPublicKey,
}

// Export for unit test
export { attachToken, attachDeviceId, makeAuthorization, attachCkoPublicKey }
export default { headers }
